import React from "react";
import PropTypes from 'prop-types'
import TableContent from "./TableContent";
import { useDispatch, useSelector } from "react-redux";
import { ButtonCommonTop } from "../Theme";

const Table = ({ title, data, isValue }) => {

    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);

    const flattenData = (valueTree, valueString = '') => {
        let flatTree = []
        for (let i = 0; i < valueTree.length; i++) {

            if (valueTree[i].hasOwnProperty('children')) {
                let childTree = flattenData(valueTree[i].children, valueString + valueTree[i].name + " - ")
                flatTree.push(...childTree)
            }
            else flatTree.push({
                name: valueString + valueTree[i].name,
                count: valueTree[i].count,
                posts: valueTree[i].posts,
                valueId: valueTree[i].value_id
            })
        }
        return flatTree
    }

    const valueTableData = data ? flattenData(data) : []

    return (
        <div className="flex flex-col lg:flex-row mt-5">
            <div className="flex flex-col mr-5 w-72 md:w-56 lg:w-72 xl:w-96">
                {isDefaultTheme === false ?
                    <ButtonCommonTop className="px-5 py-3 text-sm font-bold rounded-lg">
                        {title}
                    </ButtonCommonTop>
                    :
                    <div className="bg-gray-200 px-5 py-3 text-sm font-bold text-black rounded-lg">
                        {title}
                    </div>}
                <div className="relative pl-5 pr-16 py-3 mb-3">
                    {
                        valueTableData.map((value, index) => (
                            <TableContent
                                key={index}
                                text={value.name}
                                number={value.count}
                                dotcolor={(value.count > 0) ? 'blue' : 'gray-200'}
                                numcolor={(value.count > 0) ? 'white' : 'gray-500'}
                                valueId={value?.valueId}
                                isValue={isValue}
                            />
                        ))}
                </div>
            </div>


        </div>

    )

}

Table.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array,
}

export default Table